const AdminDashboard = () => {
  return <h1>admin only</h1>;
};

export default AdminDashboard;
